export enum MyTripsHistoryTypeEnum {
    Future,
    Past
}
